<template>
  <div v-if="paymentMethodType">
    <v-card v-for="(itemHeader, indexHeader) in paymentMethodType" :key="indexHeader" class="my-10">
      <v-card-title :class="paymentMethodTypeColor[indexHeader]">{{ indexHeader }} {{ itemHeader.sum | currencySuffixTextThEn }}</v-card-title>
      <v-card-text v-for="(item, index) in itemHeader.data" :key="index" style="padding:16px;">
        <div class="total-header">{{ index }} {{ item.sum | currencySuffixTextThEn }}</div>
        <div class="total-detail pl-5" v-if="item.type">
          <div v-for="(itemIn, indexIn) in item.type" :key="indexIn">
            <div v-if="!itemIn.data">
              {{ $t('payment.received_by') }}
              <p class="text-name">{{ indexIn }}</p>
              <b>:</b>
              <p class="text-bath">{{ itemIn.sum | currencySuffixTextThEn }}</p>
            </div>
            <div v-else>
              {{ $t('payment.account_receipt') }}
              <p class="text-name-bank">
                <img style="display: inline" width="40"
                  :src="require(`../assets/images/bank/${itemIn.data.bankCode}.jpg`)" />
                {{ BankData[itemIn.data.bankCode].name }}
                ({{ itemIn.data.accountName }} {{ itemIn.data.accountNumber }})
              </p>
              <b>:</b>
              <p class="text-bath">{{ itemIn.sum | currencySuffixTextThEn }}</p>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
  <div v-else>No Data</div>
</template>

<script>
import BankData from "@/json/bank-data.json";
export default {
  props: {
    receipts: Array,
  },
  components: {

  },
  data() {
    return {
      BankData,
      paymentMethodType: null,
      paymentMethodTypeColor: {
        [this.$t('payment.paid')]: "bg-green-100 green--text",
        [this.$t('payment.cancel_payment')]: "bg-red-100 red--text",
        [this.$t('payment.pending')]: "bg-red-100 red--text",
      },
    };
  },
  created() {
  },
  watch: {
    receipts:{
      handler(val){
        setTimeout(() => {
          this.paymentMethodTypeFn()
        }, 10);
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    // this.paymentMethodTypeFn()
  },
  methods: {
    paymentMethodTypeFn(rcIn = null) {
      let rct = {};
      let receipts = [];
      if (rcIn) receipts = rcIn;
      else receipts = this.receipts;

      if (receipts && receipts.length > 0) {
        for (const receipt of receipts) {
          if (!rct[receipt.status]) rct[receipt.status] = { sum: 0, data: {} };
          rct[receipt.status].sum += parseFloat(receipt.totalValue);
          let paymentMethod = receipt.paymentMethodText;
          if (!rct[receipt.status].data[paymentMethod])
            rct[receipt.status].data[paymentMethod] = {
              data: [],
              sum: 0,
              type: {}
            };
          if (
            rct[receipt.status].data &&
            rct[receipt.status].data[paymentMethod]
          ) {
            rct[receipt.status].data[paymentMethod].data.push(receipt);
            rct[receipt.status].data[paymentMethod].sum += parseFloat(
              receipt.totalValue
            );
          }
          if (
            rct[receipt.status].data &&
            rct[receipt.status].data[this.$t('payment.cash')] &&
            paymentMethod == this.$t('payment.cash') &&
            receipt.createdByText
          ) {
            if (!rct[receipt.status].data[this.$t('payment.cash')].type[receipt.createdByText])
              rct[receipt.status].data[this.$t('payment.cash')].type[receipt.createdByText] = {
                sum: 0
              };
            rct[receipt.status].data[this.$t('payment.cash')].type[
              receipt.createdByText
            ].sum += parseFloat(receipt.totalValue);
          }
          if (
            rct[receipt.status].data &&
            rct[receipt.status].data[this.$t('payment.bank_transfer')] &&
            paymentMethod == this.$t('payment.bank_transfer') &&
            receipt.paymentBankAccount &&
            receipt.paymentBankAccount.accountNumber
          ) {
            if (
              !rct[receipt.status].data[this.$t('payment.bank_transfer')].type[
              receipt.paymentBankAccount.accountNumber
              ]
            )
              rct[receipt.status].data[this.$t('payment.bank_transfer')].type[
                receipt.paymentBankAccount.accountNumber
              ] = { sum: 0, data: [] };
            rct[receipt.status].data[this.$t('payment.bank_transfer')].type[
              receipt.paymentBankAccount.accountNumber
            ].data = receipt.paymentBankAccount;
            rct[receipt.status].data[this.$t('payment.bank_transfer')].type[
              receipt.paymentBankAccount.accountNumber
            ].sum += parseFloat(receipt.totalValue);
          }
          if (
            rct[receipt.status].data &&
            rct[receipt.status].data[this.$t('payment.cash_check')] &&
            paymentMethod == this.$t('payment.cash_check') &&
            receipt.paymentBankAccount &&
            receipt.paymentBankAccount.accountNumber
          ) {
            if (
              !rct[receipt.status].data[this.$t('payment.cash_check')].type[
              receipt.paymentBankAccount.accountNumber
              ]
            )
              rct[receipt.status].data[this.$t('payment.cash_check')].type[
                receipt.paymentBankAccount.accountNumber
              ] = { sum: 0, data: [] };
            rct[receipt.status].data[this.$t('payment.cash_check')].type[
              receipt.paymentBankAccount.accountNumber
            ].data = receipt.paymentBankAccount;
            rct[receipt.status].data[this.$t('payment.cash_check')].type[
              receipt.paymentBankAccount.accountNumber
            ].sum += parseFloat(receipt.totalValue);
          }
          if (
            rct[receipt.status].data &&
            rct[receipt.status].data[this.$t('payment.gift_voucher')] &&
            paymentMethod == this.$t('payment.gift_voucher') &&
            receipt.createdByText
          ) {
            if (!rct[receipt.status].data[this.$t('payment.gift_voucher')].type[receipt.createdByText])
              rct[receipt.status].data[this.$t('payment.gift_voucher')].type[receipt.createdByText] = {
                sum: 0
              };
            rct[receipt.status].data[this.$t('payment.gift_voucher')].type[
              receipt.createdByText
            ].sum += parseFloat(receipt.totalValue);
          }
        }
      }
      this.paymentMethodType = rct;
      return rct;
    },
  }
};
</script>

<style lang="scss" scoped>
.total-header {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 15px;
}

.total-detail {
  font-size: 16px;

  .text-name {
    min-width: 200px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-name-bank {
    min-width: 400px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-bath {
    min-width: 150px;
    display: inline-block;
    text-align: right;
  }
}

.v-data-table::v-deep td .customer-name {
  max-width: 250px;
}

.text-nowrap-table.market-name,
.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}
</style>